import React from "react";

import { Container } from "react-bootstrap";

import Page from "components/Page/Page";
import { mapConfig } from "src/app-config";

const config = [
  {
    name: "MapPage",
    rowProps: { noGutters: true },
    moduleComponentName: "MapPage",
    moduleProps: {
      content: {
        title: "Choose a Topic",
        topics: [
          {
            id: "overview",
            title: "Overview",
            locationOptions: {},
            layerOptions: [
              { id: "photo-points-viewpoint", visible: true },
              { id: "photo-points-photomontage", visible: true },
            ],
            content: {
              elementId: "overview",
              hideContent: true,
              layerControls: [
                {
                  type: "single",
                  layer: {
                    ids: [
                      "photo-points-viewpoint",
                      "photo-points-photomontage",
                    ],
                    label: "Viewpoints and photomontages",
                  },
                },
              ],
            },
          },
          {
            id: "construction",
            title: "Construction",
            locationOptions: {},
            layerOptions: [
              { id: "decommissioning-of-existing-line-0x1", visible: true },
              {
                id: "realignment-section-of-transmission-line-0x2",
                visible: true,
              },
              { id: "haulage-routes", visible: true },
            ],
            content: {
              elementId: "construction",
              hideContent: false,
              layerControls: [
                {
                  type: "single",
                  layer: {
                    ids: ["haulage-routes"],
                    label: "Local haulage routes",
                  },
                },
                {
                  type: "single",
                  layer: {
                    ids: ["realignment-section-of-transmission-line-0x2"],
                    label:
                      "Proposed realignment of the existing 220kV transmission line (Line 0X2)",
                  },
                },
                {
                  type: "single",
                  layer: {
                    ids: ["decommissioning-of-existing-line-0x1"],
                    label:
                      "Decommissioning of existing line 0X1 (Buronga to Vic Border)",
                  },
                },
              ],
            },
          },
          {
            id: "biodiversity",
            title: "Biodiversity",
            locationOptions: {},
            layerOptions: [
              { id: "threatened-flora-wsp", visible: false },
              { id: "threatened-fauna-wsp", visible: false },
              { id: "threatened-fauna-bionet", visible: false },
              { id: "ramsar-wetland", visible: false },
              { id: "mnes-habitat-target-species", visible: false },
              { id: "ibra-regions", visible: false },
              { id: "sandhill-pine-ebc", visible: false },
              { id: "threatened-species-sighting", visible: false },
              { id: "threatened-fauna-survey", visible: false },
              { id: "fauna-strata", visible: false },
              { id: "fish-habitat", visible: false },
              { id: "disturbance-500m-buffer", visible: false },
              { id: "native-veg-cover-500m", visible: false },
              { id: "native-vegetation", visible: false },
              { id: "mitchell-landscapes", visible: false },
            ],
            content: {
              elementId: "biodiversity",
              hideContent: true,
              layerControls: [
                {
                  type: "single",
                  layer: {
                    ids: [
                      "threatened-flora-wsp",
                      "threatened-fauna-wsp",
                      "threatened-fauna-bionet",
                      "ramsar-wetland",
                      "mnes-habitat-target-species",
                    ],
                    label: "Matters of National Environmental Significance",
                  },
                },
                {
                  type: "single",
                  layer: {
                    ids: ["sandhill-pine-ebc"],
                    label: "Threatened ecological communities",
                  },
                },
                {
                  type: "single",
                  layer: {
                    ids: ["threatened-species-sighting"],
                    label: "Threatened flora species",
                  },
                },
                {
                  type: "single",
                  layer: {
                    ids: [
                      "threatened-fauna-survey",
                      "fauna-strata",
                      "fish-habitat",
                    ],
                    label: "Threatened fauna species",
                  },
                },
                {
                  type: "single",
                  layer: {
                    ids: ["disturbance-500m-buffer", "native-veg-cover-500m"],
                    label: "Native vegetation cover",
                  },
                },
                {
                  type: "single",
                  layer: {
                    ids: ["native-vegetation"],
                    label: "Native vegetation types and zones",
                  },
                },
                {
                  type: "single",
                  layer: {
                    ids: ["mitchell-landscapes"],
                    label: "Landscape features",
                  },
                },
                {
                  type: "single",
                  layer: {
                    ids: ["ibra-regions"],
                    label: "IBRA Regions",
                  },
                },
              ],
            },
          },
          {
            id: "heritage",
            title: "Heritage",
            locationOptions: {},
            layerOptions: [
              { id: "non-aboriginal-heritage-points", visible: false },
              { id: "lep-heritage", visible: false },
              { id: "lep-heritage-labels", visible: false },
              { id: "historically-significant-her", visible: false },
              { id: "historically-significant-her-border", visible: false },
              { id: "previously-unrecorded-her", visible: false },
              { id: "ahims-sites", visible: false },
              { id: "aboriginal-sites-previously-unrecorded", visible: false },
            ],
            content: {
              elementId: "heritage",
              hideContent: true,
              layerControls: [
                {
                  type: "single",
                  layer: {
                    ids: [
                      "non-aboriginal-heritage-points",
                      "historically-significant-her",
                      "historically-significant-her-border",
                      "lep-heritage",
                      "lep-heritage-labels",
                      "previously-unrecorded-her",
                    ],
                    label: "Non-Aboriginal heritage sites",
                  },
                },
                {
                  type: "single",
                  layer: {
                    ids: ["ahims-sites"],
                    label:
                      "Aboriginal Heritage Information Management System (AHIMS) sites",
                  },
                },
                {
                  type: "single",
                  layer: {
                    ids: ["aboriginal-sites-previously-unrecorded"],
                    label: "Aboriginal sites previously unrecorded",
                  },
                },
              ],
            },
          },
          {
            id: "other-issues",
            title: "Other Issues",
            locationOptions: {},
            layerOptions: [
              { id: "noise-construction-strandardhours", visible: false },
              { id: "noise-construction-outofhours-day", visible: false },
              { id: "noise-construction-outofhours-night", visible: false },
              { id: "noise-operation-audiblenoisezones", visible: false },
              { id: "noise-operation-burongass-night", visible: false },
              { id: "noise-operation-burongass-day", visible: false },
              { id: "soil-fertility", visible: false },
              { id: "groundwater-bores", visible: false },
              { id: "gde-terrestrial", visible: false },
              { id: "gde-subterranean", visible: false },
              { id: "hf-flooding", visible: false },
            ],
            content: {
              elementId: "other-issues",
              hideContent: true,
              layerControls: [
                {
                  type: "group",
                  title: "Groundwater",
                  layers: [
                    {
                      ids: ["groundwater-bores"],
                      label: "Groundwater bores",
                    },
                    {
                      ids: ["gde-terrestrial"],
                      label:
                        "Terrestrial (aquatic) Ground Dependent Ecosystems",
                    },
                    {
                      ids: ["gde-subterranean"],
                      label:
                        "Subterranean (vegetation) Ground Dependent Ecosystems",
                    },
                  ],
                },
                {
                  type: "group",
                  title: "Noise",
                  layers: [
                    {
                      ids: ["noise-construction-strandardhours"],
                      label:
                        "Construction noise - transmission line works - Standard Hours",
                    },
                    {
                      ids: ["noise-construction-outofhours-day"],
                      label:
                        "Construction noise - transmission line works - out of hours (day)",
                    },
                    {
                      ids: ["noise-construction-outofhours-night"],
                      label:
                        "Construction noise - transmission line works - out of hours (night)",
                    },
                    {
                      ids: ["noise-operation-audiblenoisezones"],
                      label: "Audible noise risk zones",
                    },
                    {
                      ids: ["noise-operation-burongass-day"],
                      label:
                        "Operational noise levels (Buronga substation upgrade and expansion area (day)",
                    },
                    {
                      ids: ["noise-operation-burongass-night"],
                      label:
                        "Operational noise levels (Buronga substation upgrade and expansion area (night)",
                    },
                  ],
                },
                {
                  type: "single",
                  layer: {
                    ids: ["hf-flooding"],
                    label: "Hydrology and flooding",
                  },
                },
                {
                  type: "single",
                  layer: {
                    ids: ["soil-fertility"],
                    label: "Estimated soil fertility",
                  },
                },
              ],
            },
          },
          {
            id: "eis-links",
            title: "Links to the EIS",
            locationOptions: {},
            layerOptions: [],
            content: {
              elementId: "eis-links",
              hideContent: true,
              layerControls: [],
            },
          },
        ],
      },
      geocoderConfig: mapConfig.geocoderConfig,
      icons: mapConfig.icons,
      layerControls: mapConfig.layerControls,
      layers: mapConfig.layers.reverse(),
      mapConfig: mapConfig.mapComponentConfig,
      sites: mapConfig.sites,
      popups: mapConfig.popups,
    },
  },
];

const InteractiveMapPage = () => {
  return (
    <Container fluid className="page-view">
      <Page config={config} />
    </Container>
  );
};

export default InteractiveMapPage;
